import React from 'react'
import RichText from '@/components/RichText'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'
import type { ButtonProps } from '@mui/material'


type CMSLinkType = {
  appearance?: 'inline' | ButtonProps['variant']
  children?: React.ReactNode
  className?: string
  label?: string | null
  newTab?: boolean | null
  size?: ButtonProps['size'] | null
  type?: 'custom' | 'reference' | null
  url?: string | null
}

type Column = {
  enableLink?: boolean
  link?: CMSLinkType
  richText?: DefaultTypedEditorState
  size?: 'full' | 'half' | 'oneThird' | 'twoThirds'
}

type ContentBlockProps = {
  columns?: Column[]
  blockType?: string
  disableInnerContainer?: boolean
  doc?: Record<string, unknown> | null
  blockName?:string
}

export const ContentBlock: React.FC<ContentBlockProps> = (props) => {
  const { columns } = props

  const colsSpanClasses = {
    full: 12,
    half: 6,
    oneThird: 4,
    twoThirds: 8,
  }

  return (
    <Box  sx={{ maxWidth: '1200px', margin: '0 auto', my: 4, px: { xs: 2, lg: 0 } }}>
      <Grid container spacing={4}>
        {columns &&
          columns.length > 0 &&
          columns.map((col: Column, index: number) => {
            const { richText, size } = col
            const gridSize = size ? colsSpanClasses[size] : 12

            return (
              <Grid size={{ xs: 12, md: gridSize }} key={index}>
                {richText && (
                  <Box
                    sx={{
                      '& img': {
                        maxWidth: '100%',
                        height: 'auto',
                        display: 'block',
                      },
                    }}
                  >
                    <RichText data={richText} enableGutter={false} />
                  </Box>
                )}
              </Grid>
            )
          })}
      </Grid>
    </Box>
  )
}
